module.exports = __webpack_public_path__ + "img/07-min.00462cf1.jpg";